// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-MfPrHgItjWLsdGUdWKtmw\\=\\= {\n  margin-top: 8px;\n  margin-bottom: 8px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}", "",{"version":3,"sources":["webpack://src/devlink/PublisherEmptyState.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAiB;KAAjB,iBAAiB;AACnB","sourcesContent":[".image-16 {\n  margin-top: 8px;\n  margin-bottom: 8px;\n  object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image-16": "-MfPrHgItjWLsdGUdWKtmw=="
};
export default ___CSS_LOADER_EXPORT___;
